import type { NivelPanelBalance } from './permissions';
import { queryDePeriodo, rutaConPeriodo } from './periodoNavegacion';

export function rutaAvisoBalance(
  nivel: NivelPanelBalance | null,
  tipo: string,
  periodo?: { mes: number; año: number },
): string {
  let ruta = '/lumisial/balance';
  if (nivel) {
    let tab = nivel === 'diocesano' ? 'jad' : 'jan';
    if (tipo === 'balance_enviado') tab = 'notificaciones';
    ruta = `/admin/balance?tab=${tab}`;
  }
  return periodo ? rutaConPeriodo(ruta, queryDePeriodo(periodo)) : ruta;
}
